import styled from "@emotion/styled";
import DefaultTimeline from "metabase/components/Timeline";

export const Header = styled.h3`
  margin-bottom: 1rem;
`;

export const Timeline = styled(DefaultTimeline)`
  padding-bottom: 1em;
`;
